import { Typo3SectionSpotHeadlessDownload } from '@/types/typo3'
import { Container, Section, SectionHeaderContent } from '@/ui/components'
import { memo } from 'react'
import Cards from './components/Cards'

interface Props {
  data: Typo3SectionSpotHeadlessDownload
}

const SpotHeadlessDownload = ({ data }: Props) => {
  const c = data?.content

  return (
    <Section data={data} className="s-spotheadless-download py-xl">
      <SectionHeaderContent
        as="h2"
        titleLayout={c?.titleLayout}
        description={c?.subtitle}
      >
        {c?.title}
      </SectionHeaderContent>
      <Container anim="fade-in">
        <Cards data={data} />
      </Container>
    </Section>
  )
}

export default memo(SpotHeadlessDownload)
